import { forwardRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
export const CAPTCHA_MSG = "Please tick \u201cI'm not a robot\u201d to continue.";

export const RecaptchaNotice = ({ testId, className = "" }) => (
  <p data-testid={testId} className={`text-xs leading-relaxed text-[#57534E] ${className}`}>
    This site is protected by reCAPTCHA and the Google{" "}
    <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="underline hover:text-[#E62314]">Privacy Policy</a> and{" "}
    <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" className="underline hover:text-[#E62314]">Terms of Service</a> apply.
  </p>
);

export const Captcha = forwardRef(({ onChange, testId }, ref) => (
  <div data-testid={testId} className="mt-6 min-h-[78px]">
    {RECAPTCHA_SITE_KEY && (
      <ReCAPTCHA ref={ref} sitekey={RECAPTCHA_SITE_KEY} onChange={(t) => onChange(t || "")} onExpired={() => onChange("")} />
    )}
  </div>
));
